import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [mobileMenuOpen]);

  const navItems = [
    { label: 'Home', href: '/' },
    { label: 'About', href: '/about' },
    { label: 'Legal & Compliance', href: '/compliance-policy' },
    { label: 'FAQ', href: '/faq' },
    { label: 'Contact', href: '/contact' },
  ];

  return (
    <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white shadow-md ${
        scrolled ? 'shadow-lg' : ''
      }`}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-center justify-between h-24">
            {/* Logo with Brand Name - Clickable - Left Aligned */}
            <a href="/" className="flex items-center gap-3 cursor-pointer -ml-12">
              <img 
                src="https://customer-assets.emergentagent.com/job_crypto-pulse-91/artifacts/jsojo49j_Black%20%26%20White%20Elegant%20Typography%20Monogram%20Logo_20251015_202607_0000.png" 
                alt="Coinexus" 
                className="h-36 w-36 object-contain hover:opacity-80 transition-opacity duration-200"
                style={{ imageRendering: '-webkit-optimize-contrast' }}
              />
              <span className="text-2xl font-bold text-[#1E3A5F] tracking-wider">Coinexus OTC</span>
            </a>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-8">
              {navItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className="text-[#1E3A5F] hover:text-[#FF6B35] transition-colors duration-200 font-semibold"
                >
                  {item.label}
                </a>
              ))}
            </nav>

            {/* CTA Button */}
            <div className="hidden md:block">
              <a href="/contact">
                <Button className="bg-gradient-to-r from-[#FF6B35] to-[#F7931E] hover:from-[#F7931E] hover:to-[#FF6B35] text-white rounded-xl px-6 py-2.5 font-semibold transition-all duration-300 hover:scale-105 shadow-md hover:shadow-lg">
                  Get Started
                </Button>
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden text-[#1E3A5F] p-2 z-50"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
          
          {/* Regulatory Trust Line - Hidden when mobile menu is open */}
          {!mobileMenuOpen && (
            <div className="text-center" style={{ paddingTop: '12px', paddingBottom: '12px' }}>
              <p style={{ fontSize: '11px', color: '#5A6B7A', fontWeight: '400', lineHeight: '1.4' }}>
                Licensed Virtual Asset Service Provider (VASP) — Poland | KRS: 0001142506
              </p>
            </div>
          )}
        </div>
      </header>

      {/* Mobile Menu - Full Screen Overlay */}
      {mobileMenuOpen && (
        <div className="fixed inset-0 z-40 md:hidden">
          <div className="fixed inset-0 bg-white pt-24 overflow-y-auto">
            <div className="max-w-7xl mx-auto px-6 py-6 space-y-4">
              {navItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className="block text-[#1E3A5F] hover:text-[#FF6B35] transition-colors duration-200 font-semibold text-lg py-3"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.label}
                </a>
              ))}
              <div className="pt-6">
                <a href="/contact" onClick={() => setMobileMenuOpen(false)}>
                  <Button className="w-full bg-gradient-to-r from-[#FF6B35] to-[#F7931E] hover:from-[#F7931E] hover:to-[#FF6B35] text-white rounded-xl transition-all duration-300 py-3">
                    Get Started
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;